import { motion } from "framer-motion";
import { Link } from "react-router";

const projects = [
  {
    id: 1,
    title: "Immigration Area at T3",
    location: "IGI AIRPORT, DELHI",
    description:
      "Seamlessly integrating high-end retail into a fast-paced transit environment. We executed this premium fit-out with precision joinery and advanced lighting systems.",
    specs: {
      area: "12,000 Sqft",
      duration: "6 Months",
      scope: "Fit-out & MEP",
    },
    image: "images/projects/t3-immigration-area.jpg",
    link: "/projects/duty-free",
  },
  {
    id: 2,
    title: "Gordon Ramsay Street Pizza",
    location: "CSMIA MUMBAI",
    description:
      "A masterclass in industrial chic aesthetics fitting within high-security airport protocols. The challenge was to bring the raw, street-style vibe of London to Mumbai's busiest terminal.",
    specs: {
      area: "3,500 Sqft",
      duration: "4 Months",
      scope: "Civil & Interiors",
    },
    image: "images/projects/gordon-ramsay.jpg",
    link: "/projects/street-pizza",
  },
  {
    id: 3,
    title: "The Flower Tunnel",
    location: "Lucknow International Airport",
    description:
      "An immersive experiential zone created through intricate glass work and digital integration. This project demonstrates our capability to handle complex, artistic installations.",
    specs: {
      area: "1,500 Sqft",
      duration: "3 Months",
      scope: "Structural Glazing",
    },
    image: "images/projects/flower-tunnel.jpg",
    link: "/projects/flower-tunnel",
  },
];

export const FeaturedProjects = () => {
  return (
    <section
      id="our-portfolio"
      className="bg-white py-24 px-6 md:px-12 lg:px-24 scroll-mt-28">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-primary font-medium tracking-widest uppercase mb-4">
            Our Portfolio
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-serif text-4xl md:text-5xl text-gray-900 mb-6">
            Landmark Installations
          </motion.h2>
          <div className="w-24 h-1 bg-gray-200 mx-auto" />
        </div>
        <div className="flex flex-col gap-32">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.8 }}
              className={`flex flex-col ${
                index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } items-center gap-12 lg:gap-24`}>
              {/* Image Side */}
              <div className="w-full lg:w-3/5 overflow-hidden group shadow-xl">
                <div className="aspect-3/2 overflow-hidden relative">
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500 z-10" />
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
              </div>

              {/* Content Side */}
              <div className="w-full lg:w-2/5 flex flex-col justify-center items-start">
                <span className="text-primary font-bold text-sm tracking-widest uppercase mb-4">
                  {project.location}
                </span>
                <h3 className="font-serif text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6">
                  {project.title}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed mb-8 font-light">
                  {project.description}
                </p>

                {/* Technical Specs Grid */}
                <div className="w-full border-t border-neutral-200 pt-6 mb-8">
                  <div className="grid grid-cols-2 gap-6">
                    <div>
                      <span className="block text-[10px] uppercase tracking-widest text-neutral-500 mb-1">
                        Area
                      </span>
                      <span className="text-sm font-medium text-neutral-800 font-sans">
                        {project.specs.area}
                      </span>
                    </div>
                    <div>
                      <span className="block text-[10px] uppercase tracking-widest text-neutral-500 mb-1">
                        Duration
                      </span>
                      <span className="text-sm font-medium text-neutral-800 font-sans">
                        {project.specs.duration}
                      </span>
                    </div>
                    <div className="col-span-2">
                      <span className="block text-[10px] uppercase tracking-widest text-neutral-500 mb-1">
                        Scope
                      </span>
                      <span className="text-sm font-medium text-neutral-800 font-sans">
                        {project.specs.scope}
                      </span>
                    </div>
                  </div>
                </div>

                <Link
                  to={"/projects"}
                  className="px-8 py-3 bg-transparent border border-primary text-primary font-semibold text-xs tracking-widest uppercase hover:bg-primary hover:text-white transition-all duration-300">
                  View More
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="mt-24 text-center">
          <Link to="/projects">
            <button className="px-8 py-4 border border-gray-900 text-gray-900 cursor-pointer uppercase tracking-widest text-xs font-bold hover:bg-gray-900 hover:text-white transition-all duration-300">
              View All Projects
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};
